'use strict';

angular.module('TurneroApp').component('coTurnoReagendado', {
	bindings: {
		turnoDetalle: '<',
		ctrlPadre: '='
	},
	controller: [
		 '$anchorScroll',
		 '$scope',
		 'turnosService',
		 '$rootScope',
		 'utilsService',
		 function (
		 $anchorScroll,
		 $scope,
		 turnosService,
		 $rootScope,
		 utilsService
) {
		 	var ctrl = this;

		 	ctrl.mostrarOtroTurno = function () {
		 		if (!ctrl.ctrlPadre.turnoDetalleReagendado) {
		 			ctrl.ctrlPadre.Id_Turno_Reagendado = ctrl.turnoDetalle.Id_Turno_Reagendado;
		 			ctrl.ctrlPadre.turnoDetalleReagendado = true;
		 		} else {
		 			ctrl.ctrlPadre.turnoDetalleReagendado = false;
		 		}
		 		$anchorScroll();
		 	};
		 }
	],
	template: require('./turnoReagendado.html')
});



// WEBPACK FOOTER //
// ./app/components/turnos/turnoReagendadoComponent.js